'use client';

import { useMemo } from 'react';
import type { TableId } from '@terra/ui-design-system';
import { useUser } from '../../app/providers/auth';

export function useListPageTablePersistence(tableId: TableId) {
  const { user } = useUser();
  const userId = user?.userId;

  return useMemo(
    () =>
      userId
        ? { tableId, userId, persistedState: 'columnLayout' as const }
        : undefined,
    [tableId, userId],
  );
}
